var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(-768.000000, -44.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(747.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7309225,42.3109225 L40.6609225,34.2409225 C44.4685485,29.6740071 44.0098123,22.919793 39.6196458,18.9096596 C35.2294794,14.8995261 28.4614343,15.0525424 24.2569884,19.2569884 C20.0525424,23.4614343 19.8995261,30.2294794 23.9096596,34.6196458 C27.919793,39.0098123 34.6740071,39.4685485 39.2409225,35.6609225 L47.3109225,43.7309225 C47.4986891,43.9202352 47.754285,44.0267208 48.0209225,44.0267208 C48.28756,44.0267208 48.5431559,43.9202352 48.7309225,43.7309225 C48.9202352,43.5431559 49.0267208,43.28756 49.0267208,43.0209225 C49.0267208,42.754285 48.9202352,42.4986891 48.7309225,42.3109225 Z M23.0209225,27.1309225 C23.0209225,22.0996084 27.0996084,18.0209225 32.1309225,18.0209225 C37.1622366,18.0209225 41.2409225,22.0996084 41.2409225,27.1309225 C41.2409225,32.1622366 37.1622366,36.2409225 32.1309225,36.2409225 C27.1018931,36.2354112 23.0264338,32.159952 23.0209225,27.1309225 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loop.2bea96920929210f0bb2f4b5c1851685.svg";